import { SadFaceIcon } from './Icons';

function StatusIndicator({
  variant = 'loading',
  label,
  className = '',
}) {
  const classes = `status-indicator status-indicator--${variant} ${className}`.trim();
  const role = variant === 'error' ? 'alert' : 'status';
  const ariaLabel = label ?? '';

  return (
    <div className={classes} role={role} aria-label={ariaLabel}>
      {variant === 'error' ? (
        <div className="status-indicator__icon">
          <SadFaceIcon size={30} />
        </div>
      ) : (
        <div className="section-loading__spinner"></div>
      )}
    </div>
  );
}

export default StatusIndicator;
